<template>
    <div class="book-location-description">
        <p>{{title}}</p>

        <div class="book-location-description__box">
            <div class="book-location-description__image">
                <img :src="image" :alt="name">
            </div>

            <div class="book-location-description__title">
                <h3>{{name}}</h3>
                <h3>{{location}}</h3>
            </div>

            <div class="book-location-description__content" v-html="address">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BookLocationDescription',

    props: {
        title: {
            type: String,
            default: ''
        },

        name: {
            type: String,
            default: ''
        },

        location: {
            type: String,
            default: ''
        },

        address: {
            type: String,
            default: ''
        },

        image: {
            type: String,
            default: ''
        }
    }
}
</script>
